export const customRecordFieldNames = {
    valueRef: 'valueRef',
    valueRefs: 'valueRefs',
    valueRefId: 'valueRefId',
    valueRefsIds: 'valueRefsIds',
} as const;

export const fieldMinHeight = 28;
